// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAndConditions__container--1u6","link":"TermsAndConditions__link--1lj"};